import api from './client';

export const uploadApi = {
  getSignature: (folder = 'uploads', resourceType = 'image') =>
    api.get(`/upload/signature?folder=${folder}&resource_type=${resourceType}`),
  getConfig: () => api.get('/upload/config'),
};
